import logo from './logo.svg';
import './App.css';
import Navbar from './Component/Home/Navbar';
import Home from './Component/Home/Home';
import { useEffect } from 'react';
import '../src/Component/Css/Mediascale.css'
import '../src/Component/Css/Medialargescale.css'
import { Accesscardprovider, useAccessCard } from './Component/ContextProvider/Accesscardprovider';
import { doLogout, getCurrentUserDetail, isLoggedIn } from './Component/Localstorage';
import { getUserData } from './Component/Firebase/User-fb';
import { useNavigate } from 'react-router-dom';

function App() {
  const navigate = useNavigate()
  const {setToast} = useAccessCard();

  const showToast = (msg, type) => {
    setToast({ message: msg, type });
  };

  useEffect(() => {
    const disableRightClick = (event) => {
      event.preventDefault();
    };
    document.addEventListener('contextmenu', disableRightClick);
    return () => {
      document.removeEventListener('contextmenu', disableRightClick);
    };
  }, []);


  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App;
